import { defineStore } from 'pinia'
import type { DeliveryPhone } from '~/types'

export const useDeliveryStore = defineStore('delivery', () => {
  const storedDelivery = useSafeStorage('delivery_address')
  const storedRedirectedFromCheckout = useSafeStorage('redirectedFromCheckout')

  const deliveryAddress = ref({
    full_name: '',
    phone: {} as DeliveryPhone | {},
    address: '',
    email: '',
    lat: null as number | null,
    lon: null as number | null,
  })
  const redirectedFromCheckout = ref<boolean>(false)
  const isWithinRadius = ref<boolean>(true)

  const setDeliveryData = (data: Partial<typeof deliveryAddress.value>) => {
    deliveryAddress.value = {
      ...deliveryAddress.value,
      ...data,
    };
    syncLocalStorage()
  }

  const setRedirectedFromCheckout = (value: boolean) => {
    redirectedFromCheckout.value = value
    useSetSafeStorage('redirectedFromCheckout', JSON.stringify(value))
  }

  if (storedRedirectedFromCheckout) {
    redirectedFromCheckout.value = JSON.parse(storedRedirectedFromCheckout) as boolean
  }

  if (storedDelivery) {
    try {
      deliveryAddress.value = JSON.parse(
        storedDelivery
      ) as typeof deliveryAddress.value
    } catch (e) {}
  }

  const syncLocalStorage = () => {
    useSetSafeStorage(
      'delivery_address',
      JSON.stringify(deliveryAddress.value ?? {})
    )
  }

  return {
    redirectedFromCheckout,
    isWithinRadius,
    deliveryAddress,

    setDeliveryData,
    setRedirectedFromCheckout,
  }
})
